// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"src_views_Bridge_Jitsi_vue":"c892dc51","src_views_Layout_vue":"13bc0fe2"}[chunkId] + ".css";
};